/*! public-events */
$(document).ready(function () {
    var publicCommentsSwitch = $(".switch > input");
    var publicCommentsSwitchText = $(".slider");

    setCommentsSwitch(publicCommentsSwitch, publicCommentsSwitchText);

    publicCommentsSwitch.change(function () {
        setCommentsSwitch(publicCommentsSwitch, publicCommentsSwitchText);
    });

    // Collapse all days
    $(".events-search-result-item-day").addClass("collapsed");
    $(".events-search-result-items-group").addClass("collapsed");

    // Day accordions
    $(".event-day-expando").click(function (e) {
        e.preventDefault();

        // collapse my parent
        var myparent = $(this).closest(".events-search-result-item-day");
        var itemGroup = myparent.next(".events-search-result-items-group");
        if (myparent.hasClass("collapsed")) {
            // Collapse all others
            $(".events-search-result-item-day").addClass("collapsed");
            $(".events-search-result-items-group").addClass("collapsed");

            myparent.removeClass("collapsed");
            itemGroup.removeClass("collapsed");
        }
        else {
            myparent.addClass("collapsed");
            itemGroup.addClass("collapsed");
        }
    });

    // Meeting types
    $('input[type=radio][name=EventTypeFilter]').click(function () {
        updateFilters();
    });

    // Meeting topics

    $('input[type=checkbox][name=EventTopicFilter]').click(function () {
        if (event.target.id == 'EventTopicFilter_empty') {
            $('input[type=checkbox][name=EventTopicFilter]').prop('checked', false);

            $("#EventTopicFilter_empty").prop('checked', true);
        }
        updateFilters();
    });

    //Meeting category
    $('input[type=radio][name=EventCategoryFilter]').click(function () {
        updateFilters();
    });

    //Meeting county
    $('input[type=checkbox][name=EventCountyFilter]').click(function () {
        if (event.target.id == 'EventCountyFilter_empty') {
            $('input[type=checkbox][name=EventCountyFilter]').prop('checked', false);

            $("#EventCountyFilter_empty").prop('checked', true);
        }
        updateFilters();
    });

    $("#event-week-range").change(function () {
        if ($("#event-week-range").val() !== '') {
            updateFilters();
        }
    });

    $("#search-events-button").click(function () {
        updateFilters();
    });

    $("#event-search-text").on('keyup', function (e) {
        e.preventDefault();
        if (e.keyCode == 13) {
            updateFilters();
        }
    });

    loadEventFilters();
});

function setCommentsSwitch(publicCommentsSwitch, publicCommentsSwitchText) {
    if (publicCommentsSwitch.is(":checked")) {
        // checked
        publicCommentsSwitchText.css("text-align", "left");
        publicCommentsSwitchText.text("on");
        $(".event-search-item-comment-period-header").show();
        $(".event-search-item-comment-period").show();
        $('.events-search-result-item-day').show();
        return;
    }
    // not checked
    publicCommentsSwitchText.css("text-align", "right");
    publicCommentsSwitchText.text("off");
    $(".event-search-item-comment-period-header").hide();
    $(".event-search-item-comment-period").hide();
    $('.events-search-result-item-day').each(function (index, element) {
        var dayContainer = $(this);
        var eventsContainer = $(this).next();
        var eventCount = eventsContainer.children(':not([style*="display: none"])').length
        if (eventCount === 0) {
            dayContainer.hide();
        }
    });
}

function updateFilters() {
    var topics = "top=" + $.grep($('input[type=checkbox][name=EventTopicFilter]:checked').map(function () { return this.value.match(/\d+/g); }).get(), Boolean).join(",");
    var eventType = "et=" + $('input[type=radio][name=EventTypeFilter]:checked').map(function () { return this.value.match(/\d+/g); }).get();
    var eventCategory = "cat=" + $('input[type=radio][name=EventCategoryFilter]:checked').map(function () { return this.value.match(/\d+/g); }).get();
    var eventCounties = "co=" + $.grep($('input[type=checkbox][name=EventCountyFilter]:checked').map(function () { return this.value.match(/\d+/g); }).get(), Boolean).join(",");

    var temp = $("#event-week-range");
    var startDateString = "";
    var searchText = "";

    if (temp.length) {
        temp = $("#event-week-range").val().split("-")[0];
        startDateString = "date=" + getEventDateStringFormat(temp);
        searchText = "searchtext=" + $("#event-search-text").val();
    }
    else {
        // Get the search text
        var searchTextInput = $(".search-dialog-container").find("input[type=text]");
        searchText = "searchtext=" + searchTextInput.val();
    }

    var url = [location.protocol, '//', location.host, location.pathname].join('');

    var faStates = getFilterAccordionStates();
    var query = "";

    if (temp.length) {
        query = [faStates, searchText, startDateString, topics, eventType, eventCategory, eventCounties].join("&");
    }
    else {
        query = [faStates, searchText, topics, eventType, eventCategory, eventCounties].join("&");
    }

    location.href = url + "?" + query;
}

function loadEventFilters() {
    var queries = {};

    if (document.location.search === "") {
        var weekRange = getWeekRangeFromStartDateString(queries["date"]);
        $("#event-week-range").val(weekRange);
        resolveAllOption();
        return;
    }

    $.each(document.location.search.substr(1).split('&'), function (c, q) {
        var i = q.split('=');
        queries[i[0].toString()] = i[1].toString();
    });

    if (queries["top"]) {
        var topics = queries["top"].split(",");
        $('input[name=EventTopicFilter]').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, topics) !== -1) {
                    $(this).prop('checked', true);
                }
            } else if ($(this).val().length == 0) {
                $(this).prop('checked', true);
            }
        });
    }

    if (queries["co"]) {
        var eventCounties = queries["co"].split(",");
        $('input[name=EventCountyFilter]').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, eventCounties) !== -1) {
                    $(this).prop('checked', true);
                }
            } else if ($(this).val().length == 0) {
                $(this).prop('checked', true);
            }
        });
    }

    if (queries["et"]) {
        var eventType = queries["et"].split(",");
        $('input[name=EventTypeFilter]').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, eventType) !== -1) {
                    $(this).prop('checked', true);
                }
            } else if ($(this).val().length == 0) {
                $(this).prop('checked', true);
            }
        });
    }
    if (queries["cat"]) {
        var eventCategory = queries["cat"].split(",");
        $('input[name=EventCategoryFilter]').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, eventCategory) !== -1) {
                    $(this).prop('checked', true);
                }
            } else if ($(this).val().length == 0) {
                $(this).prop('checked', true);
            }
        });
    }

    resolveAllOption();

    var weekRange = getWeekRangeFromStartDateString(queries["date"]);
    $("#event-week-range").val(weekRange);

    // 
    $("#event-search-text").val(decodeURI(queries["searchtext"]));

    if (queries["fa"]) {
        var fa = queries["fa"].split(",");
        loadFilterAccordionStates(fa);
    }
}

function getEventDateStringFormat(date) {
    var temp = new Date(date);

    if (temp.getFullYear() < 1970) {
        temp.setFullYear(temp.getFullYear() + 100);
    }

    var year = temp.getFullYear().toString();
    var month = ("0" + (temp.getMonth() + 1)).slice(-2);
    var day = ("0" + temp.getDate()).slice(-2);

    return year + month + day;
}

function resolveAllOption() {

    var urlParams = new URLSearchParams(window.location.search);
    var top = urlParams.get('top');
    if (top && top.length > 0) {
        $("#EventTopicFilter_empty").prop('checked', false);
    } else {
        $('input[type=checkbox][name=EventTopicFilter]').prop('checked', false);

        $("#EventTopicFilter_empty").prop('checked', true);
    }

    var co = urlParams.get('co');
    if (co && co.length > 0) {
        $("EventCountyFilter_empty").prop('checked', false);
    } else {
        $('input[type=checkbox][name=EventCountyFilter]').prop('checked', false);

        $("#EventCountyFilter_empty").prop('checked', true);
    }
}

function getWeekRangeFromStartDateString(startDateString) {
    var startDate;
    if (typeof startDateString === "undefined" || startDateString === null || startDateString === "") {
        var curr = new Date;
        var first = curr.getDate() - curr.getDay();
        startDate = new Date(curr.setDate(first))
    }
    else {
        var year = startDateString.substring(0, 4);
        var month = startDateString.substring(4, 6);
        var day = startDateString.substring(6, 8);

        startDate = new Date(year, month - 1, day);
    }

    var endDate = addDays(startDate, 6);
    return getFormattedDate(startDate) + "-" + getFormattedDate(endDate);
}

function getFormattedDate(date) {
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year.toString().substr(2, 2);
}

function getFilterAccordionStates() {
    var filterAccordions = $(".event-filter > .accordion-title");
    var fa = [];
    for (var i = 0; i < filterAccordions.length; i++) {
        if ($(filterAccordions[i]).hasClass("active")) {
            fa.push(i);
        }
    }
    if (!fa.some(q => q === 2) && fa.some(q => q === 0)) {
        fa.push(2)
    }

    return "fa=" + fa.map(String).join(",");
}

function loadFilterAccordionStates(fa) {
    if (typeof fa !== "undefined" &&
        fa !== null) {
        fa = fa.filter(Boolean);
        if (fa.length > 0) {
            var filterAccordions = $(".event-filter");

            for (var i = 0; i < fa.length; i++) {
                var activeAccordion = filterAccordions.eq(Number.parseInt(fa[i]));
                activeAccordion.addClass("active");
                activeAccordion.find(".accordion-title, .accordion-content").addClass("active");
            }
        }
        else {
            // Open types by default
            var filterAccordions = $(".event-filter").eq(0);
            filterAccordions.addClass("active");
            filterAccordions.find(".accordion-title, .accordion-content").addClass("active");
        }
    }
}

//function to add days to a given date. 
function addDays(startDate, numberOfDays) {
    var returnDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate() + numberOfDays,
        startDate.getHours(),
        startDate.getMinutes(),
        startDate.getSeconds());
    return returnDate;
}